import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loading-bar.gif'

const _withId = /*#__PURE__*/_withScopeId("data-v-559b7e64")

_pushScopeId("data-v-559b7e64")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "vue-content-center lock-frame" }, [
  /*#__PURE__*/_createVNode("div", null, "お待ちください..."),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "loading"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_white_backdrop = _resolveComponent("white-backdrop")

  return (_openBlock(), _createBlock(_Teleport, { to: "#lock" }, [
    _createVNode(_component_white_backdrop, { show: $props.lock }, {
      default: _withId(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})